import React from 'react';

import { RatingWidget } from '~/common/components/RatingWidget/RatingWidget';

import type { AggregateRating } from '~/common/types/search';

type Props = {
  aggregateRating: AggregateRating;
  serviceSlug: string;
};

export const AggregatedRatingWidget = ({
  aggregateRating,
  serviceSlug,
}: Props): React.ReactElement | null => (
  <RatingWidget aggregateRating={aggregateRating} serviceSlug={serviceSlug} />
);
